import React from "react";
import { Paper, TextField, Typography, Box, Stack, Button } from "@mui/material";

export default function EventTicketPaper({ tarif, setCount }) {
  return (
    <Paper elevation={3} sx={{ padding: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderRadius: 2 }}>
        <Box>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
                {tarif.nom}
            </Typography>
            {!!tarif.description&&<Typography variant="body2" sx={{ marginLeft: 2, color: 'text.secondary' }}>
                {tarif.description}
            </Typography>}
            <Typography variant="body1" sx={{ marginLeft: 2 }}>
                {tarif.montant?.toFixed(2)} €
            </Typography>
        </Box>

        <Stack direction="row" spacing={1} alignItems="center">
            <Button variant="outlined" size="small" color="primary" sx={{ width: 30, padding: 0, minWidth: 0, borderRadius: 2 }}
            inputProps={{ style: { display: 'none', } }}
            onClick={()=>{if(tarif.count>0)setCount(tarif.count-1)}}>-</Button>

            <TextField type="number" variant="outlined" size="small" sx={{ width: 50, '& input[type=number]': {MozAppearance: 'textfield'},
            '& input[type=number]::-webkit-outer-spin-button': {WebkitAppearance: 'none', margin: 0},
            '& input[type=number]::-webkit-inner-spin-button': {WebkitAppearance: 'none', margin: 0}  }} 
            value={tarif.count}
            slotProps={{ htmlInput: {min: 0, style: { textAlign: 'center' }}}}
            onBlur={(e)=>{if(e.target.value<0)setCount(0)}}
            onChange={(e)=> setCount(Number(e.target.value))} />

            <Button variant="outlined" size="small" color="primary" sx={{ width: 30, padding: 0, minWidth: 0, borderRadius: 2 }} 
            onClick={()=>setCount(tarif.count+1)}>+</Button>
        </Stack>
    </Paper>
  );
}